import { createRouter, createWebHistory } from 'vue-router'
import { useSmartSocietyAuthStore } from '@/stores/smartSocietyAuthStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/QueryView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/auth/login',
      name: 'auth-login',
      component: () => import('@/views/LoginView.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'home' }
    }
  ]
})

router.beforeEach(async (to) => {
  const authStore = useSmartSocietyAuthStore()
  await authStore.initialize()

  if (authStore.pendingReturnTo) {
    const target = authStore.pendingReturnTo
    authStore.pendingReturnTo = null

    if (target !== to.fullPath) {
      return target
    }
  }

  // Redirect authenticated users away from login
  if (authStore.isAuthenticated && typeof to.name === 'string' && to.name.startsWith('auth-')) {
    return { name: 'home' }
  }

  // Redirect unauthenticated users to login
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return { name: 'auth-login' }
  }

  return true
})

export default router
